import { render, staticRenderFns } from "./GeberitLogo.vue?vue&type=template&id=03814b12&scoped=true&"
var script = {}
import style0 from "./GeberitLogo.vue?vue&type=style&index=0&id=03814b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03814b12",
  null
  
)

export default component.exports